import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Stack, Typography, Grid, Button } from "@mui/material";

import ContentEngagementBarGraph from "./ContentEngagement";
import { generateClient } from "aws-amplify/api";
import { listAgreements, listUserProfiles } from "../../graphql/queries";
import AudienceChart from "./AudienceChart";
import AudienceByGender from "./AudienceByGenderChart";
import ContentViewBarGraph from "./TotalViewsChart";
import AverageWatchTimeChart from "./AverageWatchTimeChart";
import EngagementRateChart from "./EngagementRateChart";
import ContentApprovalTimeGraph from "./ContentApprovalTimeGraph";
import DashboardConfig from "../../pages/dashboardconfig";
import { useSelector } from "react-redux";
import AgreementCard from "./AgreementCard";

const ContentProviderDashboard = () => {
  const token = JSON.parse(localStorage.getItem("token") || "{}");
  const userId = token?.accessToken?.payload?.username;
  const navigate = useNavigate();
  const client = generateClient();

  const config = useSelector((state) => state.dashboardConfig.dashboardConfig);
  const [agreements, setAgreements] = useState([]);
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await client.graphql({
          query: listUserProfiles,
          variables: {
            filter: {
              userId: {
                eq: userId,
              },
            },
          },
        });
        if (response?.data?.listUserProfiles?.items[0]?.id) {
          localStorage.setItem(
            "userProfileId",
            JSON.stringify({
              userProfileId: response?.data?.listUserProfiles?.items[0]?.id,
            })
          );
        } else {
          navigate("/user");
        }
      } catch (error) {}
    };

    fetchUserProfile();
  }, []);

  useEffect(() => {
    const fetchAgreements = async () => {
      try {
        const response = await client.graphql({
          query: listAgreements,
          variables: {
            limit: 1,
          },
        });
        setAgreements(response?.data?.listAgreements?.items);
      } catch (error) {}
    };

    fetchAgreements();
  }, []);

  return (
    <div>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography my={2} variant="h4">
          Dashboard
        </Typography>
        <Button
          onClick={() => navigate("/add-new-content")}
          sx={{ textTransform: "capitalize" }}
          variant="contained"
        >
          Add New Content
        </Button>
      </Box>

      <Stack gap={4}>
        {config?.showSummaryAtPosition === "start" && agreements?.length > 0 ? (
          <Box>
            <Typography variant="h6" component={"h4"}>
              {" "}
              Summary
            </Typography>
            {agreements?.map((agreement) => (
              <AgreementCard agreement={agreement} />
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              border: "1px solid lightgrey",
              borderRadius: "10px",
              padding: "10px",
              maxWidth: "400px",
            }}
          >
            <Typography variant="h6" component={"span"}>
              No agreement created yet!
            </Typography>
          </Box>
        )}

        {config.showAudienceChart && (
          <Box
            sx={{
              border: "1px solid lightgrey",
              padding: "20px",
              borderRadius: "15px",
            }}
          >
            <Typography variant="h6">Audience</Typography>
            <Box
              sx={{
                border: "1px solid lightgrey",
                borderRadius: "15px",
                maxWidth: "500px",
                padding: "10px",
                marginBottom: "10px",
              }}
            >
              <AudienceChart />
            </Box>
          </Box>
        )}

        {config.showContentEngagementBarGraph && (
          <Box
            sx={{
              border: "1px solid lightgrey",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Audience Demographics
            </Typography>
            <Stack direction={"row"} justifyContent={"space-between"} gap={4}>
              <ContentEngagementBarGraph />
              {config.showAudienceByGender && <AudienceByGender />}
            </Stack>
          </Box>
        )}

        {config?.showSummaryAtPosition === "middle" && (
          <Box>
            <Typography variant="h6" component={"h4"}>
              {" "}
              Summary
            </Typography>
            {agreements?.map((agreement) => (
              <AgreementCard agreement={agreement} />
            ))}
          </Box>
        )}
        {config.showContentViewBarGraph && (
          <Box
            sx={{
              border: "1px solid lightgrey",
              padding: "20px",
              borderRadius: "15px",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Content Performance
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ContentViewBarGraph />
              </Grid>
              {config.showAverageWatchTimeChart && (
                <Grid item xs={6}>
                  <AverageWatchTimeChart />
                </Grid>
              )}
              {config.showEngagementRateChart && (
                <Grid item xs={6}>
                  <EngagementRateChart />
                </Grid>
              )}
              {config.showContentApprovalTimeGraph && (
                <Grid item xs={6}>
                  <ContentApprovalTimeGraph />
                </Grid>
              )}
            </Grid>
          </Box>
        )}

        {config?.showSummaryAtPosition === "end" && (
          <Box>
            <Typography variant="h6" component={"h4"}>
              {" "}
              Summary
            </Typography>
            {agreements?.map((agreement) => (
              <AgreementCard agreement={agreement} />
            ))}
          </Box>
        )}
      </Stack>
    </div>
  );
};

export default ContentProviderDashboard;
